import { DialogActions, DialogContent, Divider, IconButton, ModalDialog, Stack, Typography } from '@mui/joy';
import { FC } from 'react';
import { TfiClose } from 'react-icons/tfi';
import { useShallow } from 'zustand/react/shallow';

import { EntitlementServiceType, useFetchEntitlements } from '@MP/shared/api/hooks/contract';
import { RectangleButton } from '@MP/shared/components/Button';
import { isStimHomeEntitled } from '@MP/shared/utils/StimHomeUtils';

import { usePatientEditFormStore } from '../../providers/PatientEditFormProvider';
import {
  selectIsPatientRegistrationAgreed,
  selectIsPatientRegistrationExpired,
  selectIsStimHomeAgreed,
  selectIsStimHomeExpired,
} from '../../stores/createPatientEditFormDataStore';
import AgreementList from '../AgreementList';

export const AgreementListModalDialog: FC<{
  loading: boolean;
  onPrev: () => void;
  onClose: () => void;
  onSubmit: () => void;
}> = ({ loading, onClose, onPrev, onSubmit }) => {
  const { data: entitlements } = useFetchEntitlements(EntitlementServiceType.StimHome);

  const { sendPatientRegistration, sendStimHome, setSendPatientRegistration, setSendStimHome } = usePatientEditFormStore(
    useShallow((s) => ({
      sendPatientRegistration: s.sendPatientRegistration,
      sendStimHome: s.sendStimHome,
      setSendPatientRegistration: s.setSendPatientRegistration,
      setSendStimHome: s.setSendStimHome,
    }))
  );
  const isPatientRegistrationAgreed = usePatientEditFormStore(selectIsPatientRegistrationAgreed);
  const isPatientRegistrationExpired = usePatientEditFormStore(selectIsPatientRegistrationExpired);
  const isStimHomeAgreed = usePatientEditFormStore(selectIsStimHomeAgreed);
  const isStimHomeExpired = usePatientEditFormStore(selectIsStimHomeExpired);

  return (
    <ModalDialog sx={{ gap: '16px' }}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Typography level="h4" fontWeight={600}>
          동의서 전송
        </Typography>
        <IconButton onClick={onClose}>
          <TfiClose fontSize={20} />
        </IconButton>
      </Stack>
      <DialogContent sx={{ width: 620 }}>
        <AgreementList
          patientRegistration={sendPatientRegistration}
          showPatientRegistration={!isPatientRegistrationAgreed || isPatientRegistrationExpired}
          onChangePatientRegistration={(checked) => setSendPatientRegistration(checked)}
          stimHome={sendStimHome}
          showStimHome={isStimHomeEntitled(entitlements) && (!isStimHomeAgreed || isStimHomeExpired)}
          onChangeStimHome={(checked) => setSendStimHome(checked)}
        />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ pt: 0 }}>
        <RectangleButton disabled={!sendPatientRegistration && !sendStimHome} onClick={onSubmit} loading={loading}>
          확인
        </RectangleButton>
        <RectangleButton color="neutral" variant="outlined" onClick={onPrev} disabled={loading}>
          이전
        </RectangleButton>
      </DialogActions>
    </ModalDialog>
  );
};
